import './customSignaturePad.scss';

import * as React from 'react';

import { SignatureInput } from '../SignatureInput';
import { AutoGenerateSignature } from '../AutoGenerateSignature';
import { base64ToFile } from '../../../utils/generalUtils';
import { Icon } from '../Icon';
import { UserModel } from '../../../model/UserModel';

export interface ICustomSignaturePadProps {
    userName: string;
    singImage: string;
    instance: UserModel;
}

export interface ICustomSignaturePadState {
    singManually: boolean;
    signSaved: boolean;
    signatureFile: Blob;
    signBase64: string;
}

export class CustomSignaturePad extends React.PureComponent<ICustomSignaturePadProps, ICustomSignaturePadState> {
    constructor(props: ICustomSignaturePadProps) {
        super(props);
        this.state = {
            signSaved: true, singManually: false, signatureFile: props.instance.props.SignFile,
            signBase64: props.singImage
        };
    }

    public singManuallyLabel = 'Sign Manually';
    public singAutomaticallyLabel = 'Sign Automatically';

    get value() {
        return this.state.signatureFile;
    }

    public handleSave = async (acceptorSignature) => {
        const self = this;
        this.setState({ signBase64: acceptorSignature, signSaved: true });
        const fileObj = await base64ToFile(acceptorSignature, 'user-signature.png').then(function (file) {
            self.setState({
                signatureFile: file
            });
            return file;
        });
    }

    public render() {
        const { state: { singManually }, singAutomaticallyLabel, singManuallyLabel } = this;
        return (
            < div style={{ width: '50%' }} className="custom-signature-pad">
                {
                    this.state.signSaved ?
                        <div className="signature">
                            <Icon key={1} 
                            onClick={() => this.setState({ signSaved: false, signatureFile: null })} icon="times" />
                            <img
                                key={2}
                                src={this.state.signBase64}
                            />
                        </div>
                        :
                        <div>
                            <div>
                                {this.state.singManually ?
                                    <SignatureInput
                                        ref="manualSignature"
                                        onSave={this.handleSave}
                                    /> :
                                    <AutoGenerateSignature
                                        ref="generatedsignature"
                                        name={this.props.userName}
                                        onSave={this.handleSave}
                                    />}
                            </div>
                            <div className="change-type" >
                                {this.state.signSaved ? '' :
                                    <button
                                        type="button"
                                        onClick={() => this.setState({ singManually: !this.state.singManually })}
                                    >
                                        {singManually ? singAutomaticallyLabel : singManuallyLabel}
                                    </button>}
                            </div>
                        </div>
                }
            </div >
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/CustomSignaturePad/index.tsx